import { jsx as C } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M12 3C10.3431 3 9 3.87365 9 4.95135V20H8V11.8462C8 10.8266 6.65685 10 5 10C3.34315 10 2 10.8266 2 11.8462V20H0.928747C0.415814 20 0 20.4477 0 21C0 21.5523 0.415814 22 0.928747 22L23.0713 22C23.5842 22 24 21.5523 24 21C24 20.4477 23.5842 20 23.0713 20H22V8.2069C22 6.98806 20.6569 6 19 6C17.3431 6 16 6.98806 16 8.2069V20H15V4.95135C15 3.87365 13.6569 3 12 3Z",
    fill: "currentColor"
  }
);
export {
  t as default
};
